import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { Book } from '../shared/models/book';
import { EnrichmentPage } from '../shared/models/enrichmentPage';
import { PageEnrichmentsComponent } from '../bookShared/popups/pageEnrichments/pageEnrichments.component';
import { Page } from '../shared/models/page';
import { ELEpouchdbService } from './ELE.pouchdb.service';
import { PageCreationComponent } from '../bookShared/popups/pageCreation/pageCreation.component';
import { LiquidModel } from '../shared/models/liquidModel';
import { PageContent } from '../shared/models/pageContent';
import { Constants } from '../shared/models/constants';
import * as _ from 'lodash';
import { Mindmap } from '../shared/models/mindmap';
import { SmartviewComponent } from '../bookShared/popups/smartview/smartview.component';
import { BookData } from '../shared/models/bookData';
import { EnrichmentTabsComponent } from "../bookShared/enrichmentTabs/enrichmentTabs.component"
import { EnrichmentTabsService } from '../bookShared/enrichmentTabs/enrichmentTabs.service';
import { Component_interactionService } from '../component_interaction.service';
import { stat, constants } from 'fs';
import { createEleComponent, MycontentComponent } from '../shelf/mycontent/mycontent.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ShelfValues } from '../shared/models/shelfEnums';
import { NoteComponent } from '../bookShared/popups/Note/Note.component'
// import { ShelfComponent } from '../shelf/shelf.component';
import { BookInfoComponent } from '../bookShared/popups/bookInfo/bookInfo.component';
import { donwloadEleService } from '../bookShared/downloadELE.service';
import { IS_ElectronService } from '../shared/IS_Electron.service';
import { LoginObservableService } from '../shared/loginObservable.service';
import { ExportviewComponent } from '../bookShared/popups/export/export.component';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-ELE',
  templateUrl: './ELE.component.html',
  styleUrls: ['./ELE.component.css']
})
export class ELEComponent implements OnInit {
  currentNum: any

  public isSecLevelShown = false;
  // private Component_interactionService:Component_interactionService
  constructor(public snackBar: MatSnackBar, public dowloadservice: donwloadEleService, public dialog: MatDialog, private Component_interactionService: Component_interactionService, private enrichemntspService: EnrichmentTabsService, private pouchService: ELEpouchdbService, private http: Http, private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private elem: ElementRef, private ElectronService: IS_ElectronService, private LoginObservableService: LoginObservableService) { }
  iframeSource = undefined;
  @Input() data: any;
  // @Input() bookDataObj: any;
  public bookObj: Book;
  bookDataObj;
  // @Input() pageObj: any;

  showPagesList = false;
  jsondata;
  enrichOptions = ['icon-page-structure'];
  pageOptions = ['icon-lesson-structure-2', 'icon-Plus-Line'];
  listOfRightOptions = ['icon-Book-Export', 'icon-Presentation-V']
  public rootTabActive: boolean = true;
  public isCreatedELE: boolean = true;
  public enrichmentTabs = [];
  public currentLoadingPage: EnrichmentPage;
  globalPopupPara = <any>{};
  currentPageNumber: any = 1;
  popupParams: any = {
    height: 300,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    loadDirective: "",
    curComp: this,
    isResize: false
  };
  mindMapModel;
  loadEnrichments = true;
  reloadEditor = true;
  public pageObj: Page;
  pageEnrichmentsLength;
  pageNotesLength;
  pageContent: any;
  public pagesArray: any = [];
  updatedStyle;
  fullViewPageNumber: any
  mindMapChangedPagesArray = [];
  showFullViewDiv = false;
  selectedCreatedELEListIndex;
  // selectedELEPageEnrich = false;
  selectedNotesEnrichIndex;
  formFullViewArray = [];
  selectedELEBookmark = false;
  bookSubscription;

  @ViewChild(EnrichmentTabsComponent)

  private enrichmentTabsScope: EnrichmentTabsComponent;

  @ViewChild(MycontentComponent)
  private MycontentComponentScope: MycontentComponent;

  public internetSearchObj: any = {
    showPopup: false
  }

  public youtubeSearchObj: any = {
    showPopup: false
  }

  public googleServicesObj: any = {
    showPopup: false,
    googleServiceType: ""
  }

  public pageFromBookObj: any = {
    showPopup: false,
    bookObj: this.bookObj
  }
  public templateAsEnrichmentObj: any = {
    showPopup: false
  }

  ngOnDestroy() {
    if (this.bookSubscription) this.bookSubscription.unsubscribe();
    this.cdr.detach();
  }
  ngAfterViewInit() {
    this.getHeight();
    this.cdr.detectChanges();
  }


  ngOnInit() {
    document['eleComp'] = this;
    var self = this;
    if (this.data.bookObj) {
      this.bookObj = this.data.bookObj;
      this.bookDataObj = this.data.bookDataObj;

      this.pageObj = this.bookDataObj["" + this.bookDataObj.lastOpenedPage];

      this.currentPageNumber = this.bookDataObj.lastOpenedPage;

      if (this.pageObj == undefined) {

        this.iteratePropertiesInBookdataObj('');

      }

      this.initialize();

      if (this.bookDataObj && this.currentPageNumber && this.bookDataObj[this.currentPageNumber]) {

        if (this.bookDataObj[this.currentPageNumber]) {

          this.getEnrichmentsAndNotesLength(this.bookDataObj[this.currentPageNumber])
        }

      }

      if (this.ElectronService.IS_ELECTRON && this.bookObj.bookCategory == 0 && this.data.isBook) {
        this.isCreatedELE = false;
      }
      this.bookSubscription = this.ElectronService.isShelfBook$.subscribe(message => {
        if (message) {
          console.log("afterSubscription");
          self.isCreatedELE = false;

          self.cdr.detectChanges();
        }
      });

    }

  }


  iteratePropertiesInBookdataObj(state) {
    for (var property in this.bookDataObj) {
      if (this.bookDataObj[property] != undefined) {
        if (this.bookDataObj[property].children) {

          if (this.bookDataObj[property].id == state.id) {

            this.bookDataObj[property] = state;

          }

          else {
            this.updatePageObjectInchildren(this.bookDataObj[property].children, state)
          }

        }
      }
    }
  }

  public udpatedPageNumberFullView: any;

  updatePageObjectInchildren(item, state) {
    for (var i = 0; i < item.length; i++) {
      this.udpatedPageNumberFullView = undefined
      if (item[i].id == this.currentPageNumber) {
        if (state != '') {
          item[i] = state;
          return;
        }

        else {
          this.pageObj = item[i];
          this.getEnrichmentsAndNotesLength(this.pageObj)
        }

        break
      }

      else if (item[i].children) {

        this.updatePageObjectInchildren(item[i].children, state)
      }
    }
  }


  initialize() {
    if (this.bookObj.bookCategory == 1) {
      this.isCreatedELE = true;
      if (this.bookDataObj[this.currentPageNumber])
        this.pouchService.getPageContent(this.bookDataObj[this.currentPageNumber].contentDocId, this, this.currentPageNumber);
      else {
        this.pouchService.getPageContent(this.pageObj.contentDocId, this, this.currentPageNumber);
      }

      setTimeout(() => {
        this.showPagesContainer();
      }, 0);
    }
    else {



      setTimeout(() => {
        this.showPagesContainer();
      }, 0);
    }


  }
  showPagesContainer() {
    this.showPagesList = true;
    this.elem.nativeElement.querySelectorAll('.switchingPages')[0].classList.add('boxShadowForpagesDiv');

    this.formPagesListArray();
    setTimeout(() => {
      this.togglePagesList('');
      // var ele = this.elem.nativeElement.querySelectorAll('.pagesListItems' + this.pageObj.id)[0];
      // var element = ele.querySelectorAll('.pagesListItemsSpan')[0].classList.add('selectedColor');
    }, 1000);
  }

  loadEnrichmentTabs() {
    this.loadEnrichments = true;
  }


  onNotify(message) {
    this.reloadEditorM();

    this.isSecLevelShown = message.isSecondLevelShow;
    this.enrichmentTabs = message.enrichmentTabs;
    this.currentLoadingPage = message.currentLoadingPage;
    this.rootTabActive = message.rootTabActive;
    if (message.enrichmentTabs) this.pageObj.enrichment_page = this.enrichmentTabs;
    this.getEnrichmentsAndNotesLength(this.pageObj);
    if (!this.rootTabActive) {
      if (message.epageContent)
        this.pageContent = message.epageContent;
    }
    else {
      if (this.isCreatedELE) {
        this.pageObj = this.bookDataObj[this.currentPageNumber];
        if (this.pageObj == undefined) {
          for (var property in this.bookDataObj) {
            if (this.bookDataObj[property] != undefined)
              if (this.bookDataObj[property].children) {
                this.updatePageObjectInchildren(this.bookDataObj[property].children, '')
              }
          }

        }
        this.pouchService.getPageContent(this.pageObj.contentDocId, this, this.currentPageNumber);
      }

    }
    this.getHeight();
    this.cdr.detectChanges();

  }

  setPageConent(data, timeStamp) {

    this.reloadEditorM();
    this.pageContent = data.pageContent;
    if (timeStamp) this.currentPageNumber = timeStamp;
    this.enrichmentTabsScope.currentPageNumber = timeStamp;
  }

  reloadEditorM() {
    this.reloadEditor = false;
    var self = this;
    setTimeout(() => {
      self.reloadEditor = true;
      this.cdr.detectChanges();

    }, 100);
  }
  isshowEditOptions() {
    var isShow: boolean = false;
    if (this.rootTabActive) {
      if (this.isCreatedELE) {
        isShow = this.pageObj.type == 'blankPage' || this.pageObj.type == 'template' || this.pageObj.type == 'pageFromBook';

      }
      else
        isShow = false;

    }
    else {
      if (this.currentLoadingPage) {
        if (this.currentLoadingPage.type == "duplicateAsPage" && this.currentLoadingPage.description.url.length > 0) {
          isShow = false;
        }
        else {
          isShow = this.currentLoadingPage.type == 'blankPage' || this.currentLoadingPage.type == 'template' || this.currentLoadingPage.type == 'pageFromBook' || this.currentLoadingPage.type == 'duplicateAsPage'
            || this.currentLoadingPage.type == 'duplicateAsImage';

        }
      }
      else
        isShow = true;
    }
    return isShow;
  }
  //
  //


  togglePagesList(event) {

    // this.formPagesListArray();
    this.showPagesList = !this.showPagesList;

    var left = this.elem.nativeElement.querySelectorAll('.togglePagesDiv')[0].offsetLeft;
    var top = this.elem.nativeElement.querySelectorAll('.togglePagesDiv')[0].offsetTop;

    if (this.showPagesList == true) this.elem.nativeElement.querySelectorAll('.switchingPages')[0].classList.add('boxShadowForpagesDiv');
    else this.elem.nativeElement.querySelectorAll('.switchingPages')[0].classList.remove('boxShadowForpagesDiv');
    this.updatedStyle = {

      'top': top + 21 + 'px',
      // 'left': left + 'px'

    };

  }


  formPagesListArray() {


    var dataObj = this.bookDataObj;


    var mindmapObj = {};

    var mindmapDicObj = [];
    for (var property in dataObj) {

      if (dataObj[property].pageNumber) {
        mindmapDicObj.push(dataObj[property]);
      }
    }

    this.mindMapModel = new Mindmap();
    this.mindMapModel.rootName = this.bookDataObj.title;
    this.mindMapModel.pages = mindmapDicObj;
  }

  setCurrentLoadingPage() {//APP EDITOR LOADING --- Root Tab Not Active
    if (this.currentLoadingPage) {
      if (this.currentLoadingPage.description.url.length > 0 && this.currentLoadingPage.type == 'duplicateAsPage') {
        return false;
      }
      else {
        var res = this.currentLoadingPage.type == 'blankPage' || this.currentLoadingPage.type == 'template' || this.currentLoadingPage.type == 'pageFromBook' || this.currentLoadingPage.type == 'duplicateAsImage'
          || this.currentLoadingPage.type == 'duplicateAsPage';
        return res;
      }

    }
  }
  setRootTabLoadingPage() ////APP EDITOR LOADING --- Root Tab  Active
  {

    if (this.pageObj) {
      var res = this.pageObj.type == 'blankPage' || this.pageObj.type == 'template' || this.pageObj.type == 'mindmap' || this.pageObj.type == 'pageFromBook' || this.pageObj.type == 'duplicateAsImage' || this.pageObj.type == 'duplicateAsPage';
      return res;
    }
  }


  showGoogleServicesContainer() {


    var res = this.currentLoadingPage.type == 'youtube' || this.currentLoadingPage.type == 'spreadSheet' || this.currentLoadingPage.type == 'googleDocs' || this.currentLoadingPage.type == 'presentation'
    return res;


  }
  showInternetServiceContainer() {

    var res = this.currentLoadingPage.type == 'internet';
    return res;


  }

  openNewWindow(link) {
    window.open(link);
  }

  // getDetails() {
  //   var self = this;
  //   var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + this.bookObj.bId;
  //   var lessonPath = bookPath + '/Data/Lesson.json';
  //   this.http
  //     .get(lessonPath)
  //     .subscribe(res => {
  //       self.jsondata = JSON.parse(res['_body']);
  //       if (self.jsondata.structureJson.ELesson.Structure.node.children.length > 0) {
  //         self.pageObj = self.jsondata.structureJson.ELesson.Structure.node.children[0];
  //         if (self.enrichmentTabsScope) {
  //           self.enrichmentTabsScope.updateTabs(self.pageObj.id, 0, self.pageObj);
  //         }
  //         self.switchingPages(self.pageObj);
  //       }
  //     });
  // }

  showChildrensList(ev, info) {
    ev.stopPropagation();
    info.isChildrenShow = !info.isChildrenShow;
  }


  switchingPages(page, event) {


    _.forEach(this.elem.nativeElement.querySelectorAll('.pagesListItems'), function (elem) {

      elem.querySelectorAll('.pagesListItemsSpan')[0].classList.remove('selectedColor')
    })

    // this.elem.nativeElement.querySelectorAll('.pagesListItems').removeClass('selectedColor');

    event.currentTarget.querySelectorAll('.pagesListItemsSpan')[0].classList.add('selectedColor');


    if (localStorage.userData == 'undefined')
      var bookPath = 'assets/Nooor/Default' + '/' + this.bookObj.bId;
    else
      var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + this.bookObj.bId;
    if (page.media) {
      let url = page.media.url.replace(/\\/g, "/");
      var htmlUrl = bookPath + '/' + url;
      this.iframeSource = htmlUrl;
    }
  }
  updateUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  getFullViewPageNumber() {
    var indd = this.bookDataObj.pages.indexOf(this.currentPageNumber.toString());
    if (indd != -1) {
      return indd;
    }
  }

  clickListOfRightOptions(index, popupParams, ev) {
    if (index == 1) {

      this.showFullView('');
    }
    else if (index == 0) {


      ////In APP Feature/////

      // var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('ELE_EXPORT');
      // if (isFeatureAvailable == 'false') {
      //   this.LoginObservableService.openSubscribenowPopup();
      //   return;
      // }

      //////////

      if (this.isCreatedELE == true) {
        popupParams.CE = true;
      }
      else {
        popupParams.CE = false;
      }
      this.appendExportViewComp(popupParams, ev)
    }
  }

  appendExportViewComp(popupParams, ev) {
    popupParams.direction = 'right'
    popupParams.bookDataObj = this.bookDataObj;
    popupParams.bookObj = this.bookObj;
    popupParams.pageCount = this.bookObj.pageCount;
    popupParams.arrowPos = 350;
    popupParams.isResize = true;
    popupParams.smartview = true;
    popupParams.pageView = false;
    popupParams.width = 700;
    popupParams.height = 450;

    popupParams.loadDirective = ExportviewComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;

  }

  showFullView(state) {

    this.popupParams.showPopup = false;
    this.selectedNotesEnrichIndex = undefined;
    if (state == '') {
      this.updateFromPageenrichState = undefined;

    }
    this.currentNum = this.pageObj.pageNumber;
    if (this.enrichmentTabsScope)
      this.enrichmentTabsScope.saveEnrichments();
    this.showFullViewDiv = true;

    if (this.showPagesList = true) this.togglePagesList('');

  }

  closeElessonview() {

    if (this.showFullViewDiv) {
      this.udpatedPageNumberFullView = undefined;

      this.showFullViewDiv = !this.showFullViewDiv;
      this.currentLoadingPage = undefined;
      this.gotoPageNumber(this.pageObj.pageNumber, this.pageObj);
      // this.togglePagesList('')
      return;
    }

    if (this.bookDataObj) {
      this.bookDataObj.lastOpenedPage = this.currentPageNumber;
      if (this.enrichmentTabsScope)
        this.enrichemntspService.update(this.currentPageNumber, this.bookDataObj);
    }

    var temp = {}
    this.Component_interactionService.selectedBookData(temp);
    this.data.appendComponentsToApp('shelf');

    setTimeout(function () {
      this.getHeight();
    }, 100);

  }


  setbookData(bookData) {
    this.bookDataObj = bookData;
    // this.updatePages();
    // this.pageObj = this.bookDataObj["" + this.bookDataObj.pages[0]];
  }

  showToolPopup(ev, index) {
    if (index == 0) {

      if (this.pageObj.enrichment_page.length == 0) return
      this.selectedNotesEnrichIndex = index;

      this.popupParams.width = 700;
      this.popupParams.height = 450;
      this.popupParams.arrowPos = 80;
      this.popupParams.direction = 'right';
      this.popupParams.pageCount = this.bookObj.pageCount;
      this.popupParams.isResize = true;
      this.popupParams.showPopup = true;

      this.popupParams.currentPageDataObj = this.pageObj;
      this.popupParams.pageView = true;
      this.popupParams.smartview = false;
      this.popupParams.loadDirective = PageEnrichmentsComponent;
      this.popupParams.componentState = 'ELE';
      this.globalPopupPara = this.popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;
    }
    if (index == 1) {

      this.popupParams.direction = 'right'
      this.popupParams.currentPageDataObj = this.currentPageNumber;
      this.popupParams.bookDataObj = this.bookDataObj;
      this.popupParams.pageCount = this.bookObj.pageCount;
      this.popupParams.arrowPos = 225;
      this.popupParams.isResize = false;
      this.globalPopupPara = this.popupParams;
      this.globalPopupPara.showPopup = true;
      this.popupParams.width = 356;
      this.popupParams.height = 480;
      this.popupParams.loadDirective = NoteComponent;
      this.globalPopupPara.ev = ev;
      //this.cdr.detectChanges();
    }

  }

  showAddPageTooltip(ev, i) {
    this.popupParams.showPopup = true;
    this.selectedCreatedELEListIndex = i;
    if (i == 1) {
      this.popupParams.arrowPos = 100;
      this.popupParams.width = 180;
      this.popupParams.height = 231;
      this.popupParams.isResize = false;
      this.popupParams.loadDirective = PageCreationComponent;

      this.popupParams.direction = "right";
    }

    if (i == 0) {
      this.popupParams.componentState = 'ELE';
      this.showLessonStructure('', ev);
    }
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
  }

  showLessonStructure(state, ev) {

    this.popupParams.direction = "right";
    this.popupParams.bookDataObj = this.bookDataObj;
    this.popupParams.pageCount = this.bookObj.pageCount;
    this.popupParams.arrowPos = 300;
    this.popupParams.isResize = true;
    this.popupParams.smartview = true;
    this.popupParams.pageView = false;
    this.popupParams.width = 700;
    this.popupParams.height = 450;


    if (this.isCreatedELE == true)

      this.popupParams.hidePagesHeader = false;

    else if (this.isCreatedELE == false)

      this.popupParams.hidePagesHeader = true;


    this.popupParams.hidePagesList = true;
    this.popupParams.loadDirective = SmartviewComponent;

    if (state == 'purchase') {
      this.popupParams.componentState = 'PELE';
      this.globalPopupPara = this.popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;
    }
  }


  callBackAddPage(obj) { // pages callback From pageCreation component popup


    this.selectedCreatedELEListIndex = undefined
    if (obj && obj.type) {
      switch (obj.type) {
        case "internet":
          this.internetSearchObj.showPopup = true;
          break;
        case "youtube":
          this.youtubeSearchObj.showPopup = true;
          break;
        case "spreadSheet":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "googleDocs":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "presentation":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "pageFromBook":
          this.pageFromBookObj.showPopup = true;
          //this.pageFromBookObj.bookObj = this.bookObj
          //To avoid two way binding
          this.pageFromBookObj.bookObj = JSON.parse(JSON.stringify(this.bookObj));
          break;
        case "template":
          this.templateAsEnrichmentObj.showPopup = true;
          break;
        default:
          this.addPage(obj, obj.type);
          break;
      }

    }

  }

  async onglobalServiceCallBack(obj) { // Services callback 
    if (obj && obj.type) {
      switch (obj.type) {
        case "internet":
        case "youtube":
          this.addPage(obj, obj.type);
          break;
        case "spreadSheet":
        case "googleDocs":
        case "presentation":
          if (obj.selectedThumbs.length > 1) {
            for (var j = 0; j < obj.selectedThumbs.length; j = j + 1) {
              await this.addPage(obj.selectedThumbs[j], obj.type);
            }
          }
          else {
            this.addPage(obj.selectedThumbs[0], obj.type);
          }
          break;
        case "pageFromBook":

          if (obj.selectedThumbs.length > 0) {
            this.pageFromBookCallBack(obj.selectedThumbs, obj.type);
          }
          break;
        case "template":
          if (obj.selectedThumbs.length > 1) {
            for (var k = 0; k < obj.selectedThumbs.length; k = k + 1) {
              await this.addPage(obj.selectedThumbs[k], obj.type);
            }
          }
          else {
            this.addPage(obj.selectedThumbs[0], obj.type);
          }
          break;
        default:
          break;
      }

    }

  }

  async pageFromBookCallBack(selectedThumbs, type) {
    if (selectedThumbs.length > 1) {
      for (var i = 0; i < selectedThumbs.length; i = i + 1) {
        await this.addPage(selectedThumbs[i], type);
      }
    }
    else {
      this.addPage(selectedThumbs[0], type);
    }
  }

  async addPage(pageUrlObj, type) {

    this.bookObj.pageCount = this.bookObj.pageCount + 1;
    var timestamp = Constants.getGUID();
    var obj = {
      "name": "Page" + (this.bookObj.pageCount),
      "id": timestamp,
      "type": 'page',
      "index": this.bookObj.pageCount
    }
    this.pagesArray.push(obj);
    //this.pagesArray.insert(this.pagesArray.length-1,obj);

    this.currentPageNumber = timestamp;
    // this.pouchService.createPageContent(this, timestamp);
    var liquidModel: LiquidModel = new LiquidModel();
    var pageContent: PageContent = new PageContent();
    var page: Page = new Page();
    pageContent._id = Constants.USER + "." + timestamp + ".pageContent";
    if (pageUrlObj) {
      if (type == 'pageFromBook') {
        liquidModel.pageBgStyle = { "type": "image", "url": pageUrlObj.url, aspectRatio: true };
        pageContent.pageContent = liquidModel;
      }
      else if (type == "youtube") {
        page.description.url = "https://www.youtube.com/embed/" + pageUrlObj.videoId;
        page.description.key = pageUrlObj.videoId;
        pageContent.pageContent = liquidModel;
      }
      else if (type == "template") {
        var self = this
        await this.pouchService.getTemplatePageContent(pageUrlObj.contentDocId).then(function (res) {
          if (res) {
            pageContent.pageContent = res['pageContent']
            // self.pouchService.createPageContentDoc(pageContent, this);
          }
        });
      }
      else if (type == "internet") {
        page.description.url = pageUrlObj.url;
        if (pageUrlObj.title.length > 0) {
          page.description.key = pageUrlObj.title;
        }
        pageContent.pageContent = liquidModel;
      }
      else if (type == "googleDocs" || type == "spreadSheet" || type == "presentation") {
        page.description.url = pageUrlObj.embedLink;
        pageContent.pageContent = liquidModel;
      }
      else {
        page.description.url = pageUrlObj.url;
        pageContent.pageContent = liquidModel;
      }
      page.isCustomBg = true;
    }
    // pageContent.pageContent = liquidModel;
    pageContent.bookDocId = this.bookDataObj.bookDocId;
    this.bookDataObj.pages.push(timestamp + "");
    page.contentDocId = pageContent._id;
    page.pageNumber = this.bookObj.pageCount;
    page.title = 'Page ' + page.pageNumber;
    page.id = timestamp;
    page.type = type;
    this.bookDataObj[timestamp + ""] = page;
    this.pageObj = page;
    await this.pouchService.updateBookObj(this.bookObj);
    await this.pouchService.updateBookDataObj(this.bookDataObj, this.bookObj);
    await this.pouchService.createPageContentDoc(pageContent, this);
    await this.clickPage(obj);

    this.formPagesListArray();

  }

  gotoPageFromMindmap(obj, list) {
    this.cdr.detectChanges();
    this.pageObj = list;

    if (list) {
      this.gotoChildrenPage(obj, list);

    }
    else {

      this.clickPage(obj);
    }

  }


  gotoClickPage(pageObj){
    var obj = {
      "name": "Page" + pageObj.pageNumber,
      "id": pageObj.id,
      "type": 'page',
      "index": pageObj.pageNumber
    }
    this.clickPage(obj);
  }



  gotoPageNumber(index, list) {

    if (list.description.url.length == 0) {

      if (list.children.length > 0) {

          this.iterateChildsForDescription(list.children);        
      }
    }

    else{
      this.pageObj = list;
      this.gotoClickPage(this.pageObj)
    } 

  }

  iterateChildsForDescription(pageChildren) {

    for (var i = 0; i < pageChildren.length; i++) {

      if (pageChildren[i].description.url.length > 0) {

        this.pageObj = pageChildren[i];

        this.gotoClickPage(this.pageObj);
        return
      }

      else if (pageChildren[i].children.length > 0) {

        this.iterateChildsForDescription(pageChildren[i].children);
      }
    }


  }


  getEnrichmentsAndNotesLength(list) {
    this.pageEnrichmentsLength = (list.enrichment_page).length;
    this.pageNotesLength = (list.notes).length;

  }

  clickPage(pageObj) {

    this.currentPageNumber = pageObj.id;
    this.enrichmentTabs = [];
    this.rootTabActive = true;
    this.currentLoadingPage = undefined;
    setTimeout(() => {
      this.getHeight();
      if (this.enrichmentTabsScope) {
        this.enrichmentTabsScope.updateTabs(pageObj.id, pageObj.index, this.pageObj);

      }

      if(this.isCreatedELE)
      this.pouchService.getPageContent(this.pageObj.contentDocId, this, pageObj.id);
    }, 200);
    if (this.pageObj.enrichment_page.length > 0)
      this.getEnrichmentsAndNotesLength(this.pageObj)


    // this.pageObj = this.bookDataObj[pageObj.id];

  }


  gotoChildrenPage(pageObj, list) {

    this.currentPageNumber = pageObj.id;
    this.enrichmentTabs = [];
    setTimeout(() => {
      if (this.enrichmentTabsScope) {
        this.enrichmentTabsScope.updateTabs(pageObj.id, pageObj.index, list);
        this.enrichmentTabsScope.getEnrichmentPagesFromEleComp(list);

      }
    }, 200);
    if (list.enrichment_page) {
      this.getEnrichmentsAndNotesLength(list);

    }

    this.pageObj = list;
    this.pouchService.getPageContent(list.contentDocId, this, pageObj.id);
    this.cdr.detectChanges();

  }

  updateBookDataObj(updatedObj) {

    if (updatedObj.children == undefined) updatedObj.children = [];
    this.iteratePropertiesInBookdataObj(updatedObj);

    this.pageObj = updatedObj;
    // this.bookDataObj[this.bookDataObj.pages[updatedObj.pageNumber - 1]] = updatedObj;

    this.enrichmentTabsScope.updateTabsMindmap(this.pageObj, this.bookDataObj);
    if (this.isCreatedELE) {
      this.rootTabActive = true;
      this.pouchService.getPageContent(this.bookDataObj[this.pageObj.id.toString()].contentDocId, this, this.pageObj.id);
    }


    this.formPagesListArray();

    this.getEnrichmentsAndNotesLength(this.pageObj);

    this.cdr.detectChanges()

  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }


  updateFromPageenrichState: any;

  updatesCalledFromChild(message) {

    try {
      this.pouchService.savenote();
    }
    catch (ex) {

    }
    if (message == 'closed') {
      this.selectedCreatedELEListIndex = undefined;
      this.selectedNotesEnrichIndex = undefined;

    }

    else if (message == 'presentation') {
      if (this.pageObj.enrichment_page.length == 0) {

        this.openSnackBar('No enrichments to show presentation', '');
        return;
      }
      this.updateFromPageenrichState = message

      this.showFullView(message);

    }

    else if (message == 'download') {

      // donwloadEleService
      if (this.pageObj.enrichment_page.length == 0) {

        this.openSnackBar('No enrichments to download', '');
        return;
      }

      this.selectedNotesEnrichIndex = undefined;

      this.popupParams.showPopup = false;

      var ref = this;
      let dialogRef = this.dialog.open(createEleComponent, {
        width: '400px',
      });


      dialogRef.afterClosed().subscribe(res => {

        if (res != undefined) {
          // this.createNewElessonBook(res)
          document.getElementsByClassName('showDownloadloader')[0].classList.add('ShowPdfloader');

          this.dowloadservice.createNewElessonBook(res, this.pageObj)

        }

      });

    }

  }

  gotoSelectedPage(data) {
    this.enrichmentTabsScope.updateClickedPage(data.pageNumber - 1);

  }
  gotoEnrichmentPage(data, event) {

    var pageTraverseData = data.reverse();

    this.enrichmentTabsScope.gotoEnrichmentPage(pageTraverseData, event);

  }

  updatePagesChildren(json, mmobject, state) {

    this.mindMapChangedPagesArray = json;

    var _rev = this.bookDataObj._rev;

    var obj = new BookData();

    obj._id = this.bookDataObj._id;

    obj.lastOpenedPage = this.bookDataObj.lastOpenedPage;

    this.bookDataObj = obj;

    this.bookDataObj._rev = _rev;
    this.bookDataObj.pages = [];


    for (var i = 0; i < this.mindMapChangedPagesArray.length; i++) {
      // this.mindMapChangedPagesArray[i].id = this.mindMapChangedPagesArray[i].id.toString();
      this.bookDataObj[this.mindMapChangedPagesArray[i].id + ""] = this.mindMapChangedPagesArray[i];
      this.bookDataObj.pages.push(this.mindMapChangedPagesArray[i].id.toString())
    }

    this.pouchService.updateBookDataObj(this.bookDataObj, this.bookObj);
    this.formPagesListArray();


    if (state == 'rename' || state == 'delete') {
      this.gotoPageNumber('', mmobject);
    }


    this.getEnrichmentsAndNotesLength(mmobject);

  }

  callBackFromFullview(state) {

    if (state == 'initialLoading') {
      this.pouchService.getPageContent(this.pageObj.contentDocId, this, this.bookDataObj.lastOpenedPage);
    }

    else {

      this.pageObj = state;

      this.gotoPageNumber(this.pageObj.pageNumber, this.pageObj);
    }

  }

  callBackFromFullviewForPageEnrich(state) {
    if (state == "closeEnrichmentsFullView") {
      console.log("closeElessonview");
      this.closeElessonview();
    }
    else {
      this.pouchService.getPageContent(state, this, this.currentPageNumber);
    }
  }


  // book info popup

  showBookDetails(popupParams: any, ev, width, height, book, ShelfName): void {

    popupParams.loadDirective = BookInfoComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 130;
    popupParams.direction = "top";

    popupParams.bookDetals = true;
  }


  getHeight() {

    if (this.isCreatedELE) {
      if (this.enrichmentTabsScope) {
        if (this.enrichmentTabsScope.CurrentSelectedObj && this.enrichmentTabsScope.CurrentSelectedObj.children.length > 0 && this.enrichmentTabsScope.displayChildsOnSelection){
          document.getElementsByClassName('eleBookViewCon')[0]['style'].height = 'calc(100% - 80px)';
          document.getElementsByClassName('elessonCon')[0]['style'].minHeight = '600px';
        }
         
        else {
          document.getElementsByClassName('eleBookViewCon')[0]['style'].height = 'calc(100% - 44px)';
          document.getElementsByClassName('elessonCon')[0]['style'].minHeight = '640px';
        }
      }
      else
        document.getElementsByClassName('eleBookViewCon')[0]['style'].height = '100%';
    }
    else {
      if (this.enrichmentTabsScope) {
        if (this.enrichmentTabsScope.CurrentSelectedObj && this.enrichmentTabsScope.CurrentSelectedObj.children.length > 0 && this.enrichmentTabsScope.displayChildsOnSelection)
          document.getElementsByClassName('eleBookViewCon')[0]['style'].height = 'calc(100% - 80px)';
        else
          document.getElementsByClassName('eleBookViewCon')[0]['style'].height = 'calc(100% - 44px)';
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/ELE/ELE.component.ts